import type { IntlShape } from "react-intl";
import * as Yup from "yup";

import { MESSAGES } from "./message-definitions";

export const makeSelectFundingSchema = (intl: IntlShape) =>
  Yup.object().shape({
    requestedAmountCurrency: Yup.string().trim().required(),
    // requestedAmount positive integer with no leading zeros
    requestedAmount: Yup.number()
      .typeError(intl.formatMessage(MESSAGES.requestedAmountError))
      .positive(intl.formatMessage(MESSAGES.requestedAmountInvalidError))
      .required(intl.formatMessage(MESSAGES.requestedAmountError)),
    intendedUse: Yup.array()
      .min(1, intl.formatMessage(MESSAGES.intendedUseError))
      .of(Yup.string().trim())
      .required(intl.formatMessage(MESSAGES.intendedUseError)),
    intendedUseOther: Yup.mixed<string>()
      .nullable()
      .when("intendedUse", ([intendedUse]) => {
        return intendedUse?.includes("other")
          ? Yup.string().trim().required(intl.formatMessage(MESSAGES.intendedUseOtherSpecify))
          : Yup.string().nullable();
      }),
    preferredFundsDeploymentChoice: Yup.string<"asap" | "specific-date">().oneOf(["asap", "specific-date"]).required(),
    preferredFundsDeploymentDate: Yup.string()
      .nullable()
      .when("preferredFundsDeploymentChoice", {
        is: "specific-date",
        then: (schema) => schema.required(intl.formatMessage(MESSAGES.preferredFundsDeploymentDateError)),
      }),
  });
